import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
var css = {
  "shimmer": "oalp-1SfAk",
  "placeHolderShimmer": "oalp-2g2ty"
};
import classnames from 'classnames';
export var SkeletonLoader = function SkeletonLoader(_ref) {
  var style = _ref.style,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classnames(css.shimmer, _defineProperty({}, className, className)),
    style: style
  }));
};
export default SkeletonLoader;